import { render } from "./FormSelect.vue?vue&type=template&id=a039da56&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a039da56"

export default script